export default __webpack_public_path__ + "static/media/3.48e8b994.jpeg";